<template>
    <div>
        <div v-if="isDoorNotCertifed() && this.hasTopPannel" class="body-2 lighter-text red--text">
            {{$t('achtungOBH')}}
        </div>
        <v-checkbox class="mt-2" :disabled="getNrOfValuesByCharacteristic('KTU_MM_O_STUMPF') < 2"
            :input-value="getRegisteredCharacteristicsValue('KTU_MM_O_STUMPF', measureContext).value.value === 'JA'"
            :label="getCharacteristicAndValues('KTU_MM_O_STUMPF').description"
            @change="checkBoxAddCharacteristic('KTU_MM_O_STUMPF'); calculateDependentedCharacteristics()">
        </v-checkbox>

        <div class="mb-4">
            <div class="font-weight-bold mb-3">{{$t('masseOberblende')}}</div>
            <div class="d-flex mb-5">
                <div class="mr-4" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('gewunschteDurchganslichtehohe')}}</div>
                    <v-text-field class="unit-text-field" :disabled="!this.hasTopPannel" v-model="DesiredDoorHeight" style="" dense outlined
                        hide-details value="100" suffix="mm">
                    </v-text-field>
                </div>
                <div class="" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('hoheOberblende')}}</div>
                    <v-text-field class="unit-text-field" disabled v-model="TopPanelHeight" style="" dense outlined hide-details value="100"
                        suffix="mm">
                    </v-text-field>
                </div>
            </div>
        </div>


        <div class="mb-4">
            <div class="font-weight-bold mb-3">{{$t('zertifizierterBereichOberblende')}}</div>
            <div class="d-flex mb-5">
                <div class="mr-4" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('minimaleOBH')}}</div>
                    <v-text-field class="unit-text-field" disabled style="" dense outlined hide-details :value="doorLeafSizesData.minUpperPanelHeight" suffix="mm">
                    </v-text-field>
                </div>
                <div class="" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('maximaleOBH')}}</div>
                    <v-text-field class="unit-text-field" disabled style="" dense outlined hide-details :value="doorLeafSizesData.maxUpperPanelHeight" suffix="mm">
                    </v-text-field>
                </div>
            </div>
            <!-- <div class="d-flex">
                <div class="" style="width: calc(50% - 8px);">
                    <div class="body-2 pb-2" style="">{{$t('maximaleSTHLOBH')}}</div>
                    <v-text-field class="unit-text-field" disabled style="" dense outlined hide-details :value="doorLeafSizesData.maxSTLH+doorLeafSizesData.maxUpperPanelHeight" suffix="mm">
                    </v-text-field>
                </div>
            </div> -->
        </div>
    </div>

    <!-- <div>        
        <label class="label-desc top-label">Achtung: OBH nicht im zertifiziertem Bereich</label>
        <h1 class="title">Oberblende</h1>
        <div class="group-wrapper">
            <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">
                <label @click="checkBoxAddCharacteristic('KTU_MM_O_STUMPF')" class="btn btn-secondary" 
                :class="{'active': getRegisteredCharacteristicsValue('KTU_MM_O_STUMPF', measureContext).value.value === 'JA', 
                'c-disabled': getNrOfValuesByCharacteristic('KTU_MM_O_STUMPF') < 2 }">
                    <div class="check-btn">
                        <span></span>
                    </div>
                    <input type="checkbox" autocomplete="off"> {{ getCharacteristicAndValues('KTU_MM_O_STUMPF').description }}
                </label>
            </div>
        </div>
        <div class="group-wrapper margin-bottom">
            <label class="input-label">Maße Oberblende</label>
            <div :class="{'input-group' : true, 'disabled' : !this.hasTopPannel}">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Gewunschte Durchganslichtehohe der Tur</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" placeholder="Höhe [DLH] Tur"
                   :disabled="!this.hasTopPannel" v-model="DesiredDoorHeight" value="" aria-describedby="inputGroup-sizing-default">
                <span class="post">mm</span>
            </div>
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Höhe Oberblende</span>
                </div>
                <input type="text" class="form-control" v-model="TopPanelHeight" aria-label="Default" placeholder="Höhe [OBH]"
                    disabled aria-describedby="inputGroup-sizing-default">
                <span class="post">mm</span>
            </div>
        </div>
        <label class="input-label margin-top">Zertifizierter Bereich Oberblende</label>
        <div class="disabled-inputs">
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Minimale OBH</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" value="350">
                <span class="post">mm</span>
            </div>
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Maximale OBH</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" value="1000">
                <span class="post">mm</span>
            </div>
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Maximale STHL +
                        OBH</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" value="4080">
                <span class="post">mm</span>
            </div>
        </div>                            
    </div> -->
</template>
<script>
    import Vue from 'vue';
    import {
        mapActions
    } from 'vuex';
    import {
        mapGetters
    } from 'vuex';
    import {
        DoorConfiguration
    } from '../../../configurator/DoorConfiguration';
    import {parseToGermanFloat, parseFloatFromGermanFloat} from '../../../services/ParserService';

    export default Vue.extend({
        name: 'TopPanel',
        props: {
            doorLeafSizesData: Object
        },
        data() {
            return {
                parseToGermanFloat: parseToGermanFloat,
                parseFloatFromGermanFloat: parseFloatFromGermanFloat,
                measureContext: DoorConfiguration.Measure,
                hasTopPannel: false,
                DesiredDoorHeightValue: 0,
                TopPanelHeightValue: 0,
            }
        },
        computed: {
            ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration',
                'getRegisteredCharacteristicsValue'
            ]),
            ...mapGetters('measureModule', ['getCharacteristicAndValues', 'getNrOfValuesByCharacteristic',
                'checkRadioValue'
            ]),
            DesiredDoorHeight: {
                //getter
                get: function () {
                    this.DesiredDoorHeightValue = this.getRegisteredCharacteristicsValue("KTU_MM_DGLH_O",
                        this.measureContext).value.value;
                    return this.parseToGermanFloat(this.DesiredDoorHeightValue);
                },
                // setter
                set: function (newValue) {
                    newValue = this.parseFloatFromGermanFloat(newValue);
                    this.DesiredDoorHeightValue = newValue;
                    this.valueAddCharacteristic({
                        characteristicValue: this.getCharacteristicAndValues("KTU_MM_DGLH_O"),
                        value: newValue
                    });
                }
            },
            TopPanelHeight: {
                //getter
                get: function () {
                    this.TopPanelHeightValue = this.getRegisteredCharacteristicsValue("KTU_MM_O_HOEHE", this
                        .measureContext).value.value;
                    return this.parseToGermanFloat(this.TopPanelHeightValue);
                },
                // setter
                set: function (newValue) {
                    newValue = this.parseFloatFromGermanFloat(newValue);
                    this.TopPanelHeightValue = newValue;
                    this.valueAddCharacteristic({
                        characteristicValue: this.getCharacteristicAndValues("KTU_MM_O_HOEHE"),
                        value: newValue
                    });
                }
            },
            stumpfOberblendeChange: function () {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue("KTU_MM_O_STUMPF", this.measureContext).value
                    .value;
            },
        },
        watch: {
            // Whenever the stumpfOberblende computed prop changes, new filter is applied
            stumpfOberblendeChange(stumpfOberblendeChange) {
                var hasTopPanel = this.$store.getters['configuratorModule/getCurrentDoorConfiguration'].GetHasTopPannel();
                if(hasTopPanel === true)
                {
                    this.setCharacteristicDependencies('KTU_MM_OBERBLENDE');
                }
            }
        },
        methods: {
            ...mapActions('configuratorModule', ['updateDoorConfiguration']),
            ...mapActions('measureModule', ['addCharacterisitc', 'checkBoxAddCharacteristic',
                'valueAddCharacteristic', 'setCharacteristicDependencies'
            ]),
            calculateDependentedCharacteristics(){
                this.$store.dispatch('measureModule/setDoorWidthMeasurements');
            },
            isDoorNotCertifed: function(){

                if(!this.minValue(this.TopPanelHeightValue, this.doorLeafSizesData.minUpperPanelHeight))
                    return true
                else 
                    return !this.maxValue(this.TopPanelHeightValue, this.doorLeafSizesData.maxUpperPanelHeight);
            },
            minValue(value,min) {
                return (value || "") >= min || false;
            },
            maxValue(value,max) {
                return (value || "") <= max || false;
            },
        },
        mounted() {
            console.log(this.doorLeafSizesData);
            this.hasTopPannel = this.$store.getters['configuratorModule/getCurrentDoorConfiguration']
                .GetHasTopPannel();
        }

    });
</script>
<style lang="scss" scoped>
    .lighter-text {
        color: #656565;
    }
</style>